/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UiPreferences } from '../../models/ui-preferences';

export interface GlobalSettingsGetGlobalSettings$Params {
}

export function globalSettingsGetGlobalSettings(http: HttpClient, rootUrl: string, params?: GlobalSettingsGetGlobalSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<UiPreferences>> {
  const rb = new RequestBuilder(rootUrl, globalSettingsGetGlobalSettings.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UiPreferences>;
    })
  );
}

globalSettingsGetGlobalSettings.PATH = '/api/GlobalSettings/getGlobalSettings/fetch';
